import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NewInstalledUnitsCountService } from 'src/app/services/newInstalledUnitsCount/newInstalledUnitsCount.service';

@Component({
    selector: 'app-newInstalledUnitsCount-card',
    templateUrl: './newInstalledUnitsCount-card.component.html',
    styleUrls: ['./newInstalledUnitsCount-card.component.scss'],
})
export class NewInstalledUnitsCountCardComponent implements OnInit {

    newInstalledUnitsCount$ = new BehaviorSubject<string | undefined>(undefined);

    constructor(
        private _newInstalledUnitsCountService: NewInstalledUnitsCountService
    ) {

    }

    ngOnInit() {
        this._newInstalledUnitsCountService.getTankData$("7").subscribe(result => {
            this.newInstalledUnitsCount$.next(result.scalar);
        });
    }
}
